import { ChangeDetectorRef, Component, ElementRef, HostListener, PLATFORM_ID, ViewChild, inject } from '@angular/core';
import { DocumentSpecificSearchService } from '../document-specific-search.service';
import { ProductListService } from 'src/app/services/feature/product-list.service';
import { FormControl, FormGroup } from '@angular/forms';
import { ViewConfig, ViewModes } from '@spartacus/storefront';
import { BehaviorSubject, Subscription } from 'rxjs';
import { isPlatformBrowser, ViewportScroller } from '@angular/common';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { RecentSearchService } from 'src/app/services/feature/Recent-Search/recent-search.service';
import { KBLanguageService } from 'src/app/services/sapSpartacus/kbLanguageService/KbLang-service.service';

@Component({
  selector: 'app-kb-doc-search-page',
  templateUrl: './kb-doc-search-page.component.html',
  styleUrls: ['./kb-doc-search-page.component.scss'],
  standalone: false
})
export class KbDocSearchPageComponent {

  productListService = inject(ProductListService);
  scrollConfig = inject(ViewConfig);
  private kbDocService = inject(DocumentSpecificSearchService);
  private viewportScroller = inject(ViewportScroller);
  private cdr = inject(ChangeDetectorRef);
  private bpo = inject(BreakpointObserver);
  private activatedroute = inject(ActivatedRoute);
  private recentSearch = inject(RecentSearchService);
  private langservice = inject(KBLanguageService);
  private router = inject(Router)

  ApiData: any;
  ApiDataSearch: any;
  isMobile: boolean = false;
  recentSearches: any[] = [];
  searchInput: string = '';

  isInfiniteScroll: boolean | undefined;
  defaultPageSize: any = 20;

  docModel: any;
  viewMode$ = new BehaviorSubject<ViewModes>(ViewModes.Grid);
  ViewModes = ViewModes;

  currentPage;
  pageSize;
  sortKey: string = '';

  avoidPageLoadCall: boolean = false;
  changeFormData: boolean = false;
  platformId = inject(PLATFORM_ID);
  //Document Search form
  subscription = new Subscription();
  docSearchForm = new FormGroup({
    searchKey: new FormControl(''),
    productCategory: new FormControl(null),
    docType: new FormControl(null),
    language: new FormControl(null),
  });
  SearchQuery: string;

  get form() {
    return this.docSearchForm.controls;
  }

  @ViewChild('searchInput') searchInputDoc!: ElementRef;
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInsideComponent = (event.target as HTMLElement).closest('.docInputSearch');
    if (!clickedInsideComponent) {
      this.hideRecentSearches(); // Hide the dropdown when clicking outside the component
    }
  }

  updateRecentSearches(): void {
    this.recentSearches = this.recentSearch.getRecentSearches('DocRecentSearchBox');
  }

  onSearch(event: Event): void {
    //  event.preventDefault();
    this.recentSearch.saveRecentSearch(this.searchInput, 'DocRecentSearchBox');
    this.updateRecentSearches();
  }

  onSearchInput(event: any): void {
    this.searchInput = event.target.value;
    if (this.searchInput.length >= 1) {
      this.hideRecentSearches();
    } else {
      this.showRecentSearches();
    }
  }

  clearRecentSearch(): void {
    this.hideRecentSearches();
  }

  showRecentSearches(): void {
    if (isPlatformBrowser(this.platformId)) {
      const recentSearchPopup = document.querySelector('.RecentSearchDOCPopUP');
      if (recentSearchPopup) {
        recentSearchPopup.classList.add('show');
      }
    }
  }

  hideRecentSearches(): void {
    if (isPlatformBrowser(this.platformId)) {
      const recentSearchPopup = document.querySelector('.RecentSearchDOCPopUP');
      if (recentSearchPopup) {
        recentSearchPopup.classList.remove('show');
      }
    }
  }

  populateSearchInput(value: string): void {
    this.docSearchForm.controls['searchKey'].setValue(value);
    this.searchInputDoc.nativeElement.value = value;
    this.hideRecentSearches();
  }

  ngOnInit() {
    this.productListService.selectedTabIndex.next(7);
    this.avoidPageLoadCall = false;
    this.changeFormData = false;
    this.updateRecentSearches();
    this.reset();
    this.subscription.add(this.bpo.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
      this.isMobile = result.matches;
      if (this.isMobile) {
        this.setViewMode(this.ViewModes.Grid);
      } else {
        this.setViewMode(this.ViewModes.List);
      }
    }));
    this.routePatcher();
    this.isInfiniteScroll = this.scrollConfig.view?.infiniteScroll?.active;
    this.formDataApiCaller();
  }

  ngAfterViewInit() {
    this.subscription.add(this.langservice.getActive().subscribe((lang: any) => {
      if (this.avoidPageLoadCall) {
        this.search(this.currentPage, this.pageSize, this.sortKey);
        this.formDataApiCaller();
      } else if (this.changeFormData) {
        this.formDataApiCaller();
      }
    }));
  }
  routePatcher() {

    this.subscription.add(this.activatedroute.queryParamMap.subscribe((params: any) => {

      const hasSearchParams =
        params.get('text') ||
        params.get('docType') ||
        params.get('docCategory') ||
        params.get('docLanguage');
      const canCallApi = !!params?.banner;
      if (hasSearchParams) {
        this.docSearchForm.controls.searchKey.setValue(
          params.get('text') || ''
        );
        this.docSearchForm.controls.docType.setValue(
          params.get('docType') || null
        );
        this.docSearchForm.controls.productCategory.setValue(
          params.get('docCategory') || null
        );
        this.docSearchForm.controls.language.setValue(
          params.get('docLanguage') || null
        );
      }
      if (canCallApi) {
        this.docSearchForm.controls.docType.setValue('Up2Date');
      }
      if (hasSearchParams || canCallApi) {

        this.search(
          0,
          this.defaultPageSize,
          this.sortKey
        );
        return;
      }
    }));

  }
  // routePatcher() {
  //   this.activatedroute.queryParamMap.subscribe((params: any) => {
  //     if (params.get('text') || params.get('docType') || params.get('docCategory') || params.get('docLanguage')) {
  //       this.docSearchForm.controls.searchKey.setValue(params.get('text') || '');
  //       this.docSearchForm.controls.docType.setValue(params.get('docType') || null);
  //       this.docSearchForm.controls.productCategory.setValue(params.get('docCategory') || null);
  //       this.docSearchForm.controls.language.setValue(params.get('docLanguage') || null);
  //       this.search(0, this.defaultPageSize, this.sortKey);
  //     }
  //   });
  //   this.activatedroute.queryParams.subscribe((params: any) => {
  //     const canCallApi = (params && params?.banner) ? true : false;
  //     if (canCallApi) {
  //       this.docSearchForm.controls.docType.setValue('Up2Date');
  //       this.search(0, this.defaultPageSize, this.sortKey);
  //     }
  //   });
  // }

  formDataApiCaller() {
    this.subscription.add(this.kbDocService.getDocSearchPage().subscribe((data: any) => {
      this.ApiDataSearch = data;
      this.changeFormData = true;
      this.cdr.detectChanges();
    }));
  }

  reset() {
    this.docSearchForm.reset();
    this.productListService.selectedTabIndex.next(0);
    this.productListService.seperateDocDetails$.next(null);
  }

  search(currentPage: any, pageSize: any, sort: string, model?) {
    this.currentPage = currentPage;
    this.pageSize = pageSize;
    this.sortKey = sort;
    if (model) {
      this.SearchQuery = this.productListService.DecodeQuery(model?.currentQuery?.query?.value)
    }
    else {
      this.SearchQuery = this.form.searchKey.value ?? '';
    }
    const ApiPayload = {
      searchKey: this.SearchQuery,
      productCategory: (this.form.productCategory.value === null || this.form.productCategory.value === 'null') ? '' : this.form.productCategory.value,
      docType: (this.form.docType.value === null || this.form.docType.value === 'null') ? '' : this.form.docType.value,
      language: (this.form.language.value === null || this.form.language.value === 'null') ? '' : this.form.language.value
    };
    this.router.navigate([], {
      queryParams: {
        text: this.form.searchKey.value ?? '',
        docType: ApiPayload.docType,
        docCategory: ApiPayload.productCategory,
        docLanguage: ApiPayload.language
      },
      queryParamsHandling: 'merge',
    });
    this.subscription.add(this.productListService.getCustomDocumentDetails(ApiPayload, pageSize, currentPage, sort).subscribe((data: any) => {
      this.productListService.seperateDocDetails$.next(data);
      this.productListService.selectedTabIndex.next(7);
      this.productListService.isDocpaginationClickEvent = false;
      this.avoidPageLoadCall = true;
      this.cdr.detectChanges();
    }));
  }

  changePageSize(pageSize: any, modal: any) {
    this.defaultPageSize = pageSize;
    this.search(0, pageSize, this.sortKey, modal);
  }

  changePage(page: number, model: any) {
    this.search(page, model.pagination.pageSize, model.pagination.sort, model);
  }

  sortList(e, model) {
    this.sortKey = e;
    this.search(0, this.defaultPageSize, e, model);
  }

  changePageCustom(currentPage, model) {
    this.viewportScroller.scrollToPosition([0, 200]);
    this.productListService.isDocpaginationClickEvent = true;
    this.search(currentPage, model.pagination.pageSize, model.pagination.sort, model);
  }

  setViewMode(mode: ViewModes): void {
    this.viewMode$.next(mode);
  }

  ngOnDestroy() {
    this.avoidPageLoadCall = false;
    this.changeFormData = false;
    this.subscription.unsubscribe();
    this.reset();
  }
}
